<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="flex flex-col h-[calc(100dvh-120px)]">

    <!-- HEADER INTERNO -->
    <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6 flex justify-between items-center flex-shrink-0">
        <div class="flex items-center gap-4">
           
            <div class="flex flex-col">
                <span class="text-lg font-semibold text-westetics-neutral-950">Gerar Documentos</span>
                <span class="text-sm text-westetics-neutral-600">
                    Selecione os documentos que deseja gerar
                </span>
            </div>
        </div>
        <div class="flex gap-3">
            <button 
                (click)="goBack()"
                class="px-4 py-2 text-sm font-medium  rounded-lg  transition-colors text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border"
            >
                Cancelar
            </button>
            <button 
                (click)="generateDocs()"
                [disabled]="!isFormValid()"
                class="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors"
                [ngClass]="isFormValid() ? 'bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white' : 'bg-gray-300 cursor-not-allowed'"
            >
                Avançar
            </button>
        </div>
    </div>

    <!-- CONTEÚDO SCROLLÁVEL -->
    <div class="flex-1 overflow-y-auto">
        <div class="max-w-3xl">

            <!-- DOCUMENTOS PRÉ-DEFINIDOS -->
            <div class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4 flex items-center gap-2">
                    <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600"></fa-icon>
                    Documentos Pré-definidos
                </h3>
                
                <div *ngIf="requiredDocs.length === 0" class="text-sm text-gray-500">
                    Nenhum documento pré-definido
                </div>

                <ul class="space-y-2">
                    <li *ngFor="let doc of requiredDocs" class="flex items-center justify-between gap-3 p-3 bg-westetics-purple-50 border border-westetics-purple-300 rounded-lg">
                        <div class="flex items-center gap-3 min-w-0">
                            <div class="w-8 h-8 min-w-[2rem] flex-shrink-0 flex items-center justify-center bg-westetics-purple-600 rounded-lg">
                                <fa-icon [icon]="faCheck" class="text-white text-sm"></fa-icon>
                            </div>
                            <span class="text-sm font-medium text-westetics-purple-800">{{ doc.name }}</span>
                        </div>
                        <div class="text-westetics-purple-600 flex-shrink-0">
                            <fa-icon [icon]="faCheck"></fa-icon>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- ESCOLHA UM DOS TERMOS (TCLE) -->
            <div *ngIf="tcleFiles.length > 0" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-2 flex items-center gap-2">
                    <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600"></fa-icon>
                    Escolha um dos Termos
                </h3>
                <p class="text-sm text-gray-500 mb-4">Selecione pelo menos um termo para continuar</p>

                <!-- Aviso se nenhum selecionado -->
                <div *ngIf="tcleFiles.length > 0 && selectedTcles.length === 0" class="flex items-center gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg mb-4">
                    <fa-icon [icon]="faCircleExclamation" class="text-yellow-600"></fa-icon>
                    <span class="text-sm text-yellow-800">Selecione pelo menos um termo para continuar</span>
                </div>

                <ul class="space-y-2">
                    <li 
                        *ngFor="let tcle of tcleFiles" 
                        (click)="toggleTcle(tcle.id)"
                        class="flex items-center justify-between p-3 rounded-lg border cursor-pointer transition-colors"
                        [ngClass]="isTcleSelected(tcle.id) ? 'bg-westetics-purple-50 border-westetics-purple-300' : 'bg-white border-gray-200 hover:bg-gray-50'"
                    >
                        <div class="flex items-center gap-3 min-w-0">
                            <div 
                                class="w-8 h-8 min-w-[2rem] flex-shrink-0 flex items-center justify-center rounded-lg"
                                [ngClass]="isTcleSelected(tcle.id) ? 'bg-westetics-purple-600' : 'bg-gray-100'"
                            >
                                <fa-icon 
                                    [icon]="isTcleSelected(tcle.id) ? faCheck : faFileAlt" 
                                    [ngClass]="isTcleSelected(tcle.id) ? 'text-white' : 'text-gray-500'"
                                    class="text-sm"
                                ></fa-icon>
                            </div>
                            <span class="text-sm font-medium" [ngClass]="isTcleSelected(tcle.id) ? 'text-westetics-purple-800' : 'text-gray-800'">
                                {{ tcle.name }}
                            </span>
                        </div>
                        <div *ngIf="isTcleSelected(tcle.id)" class="text-westetics-purple-600 flex-shrink-0">
                            <fa-icon [icon]="faCheck"></fa-icon>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Mensagem se não há termos -->
            <div *ngIf="tcleFiles.length === 0" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-2 flex items-center gap-2">
                    <fa-icon [icon]="faFileAlt" class="text-westetics-purple-600"></fa-icon>
                    Termos
                </h3>
                <p class="text-sm text-gray-500">Nenhum termo disponível</p>
            </div>

            <!-- DOCUMENTOS OPCIONAIS -->
            <div *ngFor="let optionalDoc of optionalDocs; let i = index" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4">
                    Deseja adicionar {{ optionalDoc.name }}?
                </h3>
                
                <div class="flex gap-6">
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input 
                            type="radio" 
                            [name]="'optional_' + i"
                            [checked]="getOptionalDocValue(optionalDoc.id)"
                            (change)="onChangeOptionalDoc(i, true)"
                            class="w-4 h-4 accent-westetics-purple-800"
                        />
                        <span class="text-sm font-medium text-gray-700">Sim</span>
                    </label>
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input 
                            type="radio" 
                            [name]="'optional_' + i"
                            [checked]="!getOptionalDocValue(optionalDoc.id)"
                            (change)="onChangeOptionalDoc(i, false)"
                            class="w-4 h-4 accent-westetics-purple-800"
                        />
                        <span class="text-sm font-medium text-gray-700">Não</span>
                    </label>
                </div>
            </div>

            <!-- ESPAÇO FINAL -->
            <div class="h-6"></div>

        </div>
    </div>

</div>
</ng-container>
